import React, { useEffect, useState } from 'react';
import { SpeakerphoneIcon } from '@heroicons/react/outline';
import { Label } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../../../utils/globals';
import { Link } from '../../../Elements/Link';
import { Button } from '../../../Elements';

export const PureCookieBanner = ({ label, button, link, isProduct }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setOpen(!window.localStorage['cookie-accept']);
    }
  }, []);

  const handleCookieAccept = () => {
    if (typeof window !== 'undefined') {
      setOpen(false);
      window.localStorage.setItem('cookie-accept', true);
    }
  };

  return (
    <div
      className={`z-20 ${
        open
          ? 'opacity-100 pointer-events-auto'
          : 'opacity-0 pointer-events-none'
      } ${
        isProduct ? 'bottom-24 lg:bottom-0' : 'bottom-0'
      } rounded-xl m-2  lg:bottom-0 lg:rounded-none lg:m-0 bg-primary border-t-2 border-white fixed z-10 inset-x-0 bottom-0`}>
      <div className='max-w-7xl mx-auto py-4 px-4 sm:px-4 lg:px-8'>
        <div className='flex items-center justify-between flex-wrap'>
          <div className='w-0 flex-1 flex items-center'>
            <span className='hidden lg:flex p-2 rounded-lg bg-primary'>
              <SpeakerphoneIcon
                className='h-8 w-8 text-white'
                aria-hidden='true'
              />
            </span>
            <Label
              {...label}
              // use decoration prop to pass custom style
              decoration={'lg:text-sm'}
              size={'xs'}
              color={{ classname: 'white' }}
              text={
                <>
                  {label?.text}
                  <span className='ml-2 lg:hidden'>
                    <Link
                      {...link}
                      label={{
                        ...link.label,
                        type: 'span',
                        color: { classname: 'white' },
                        decoration: 'underline',
                      }}
                    />
                  </span>
                </>
              }
            />
            <span className='hidden lg:ml-2 lg:block'>
              <Link
                {...link}
                label={{
                  ...link.label,
                  type: 'span',
                  color: { classname: 'white' },
                  decoration: 'underline',
                }}
              />
            </span>
          </div>
          <div className='order-2 flex-shrink-0 sm:order-3 ml-6'>
            <Button
              {...button}
              onClick={handleCookieAccept}
              type='contained'
              size='sm'
              color={{ classname: 'white' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const CookieBanner = ({ isProduct, ...props }) => (
  <PureCookieBanner
    isProduct={isProduct}
    {...formatContentfulComponentProps(props)}
  />
);
